export enum PrivateNoteLocation {
  PROPOSAL_DETAIL = 'PROPOSAL_DETAIL',
  OFFER_DETAIL = 'OFFER_DETAIL',
  OFFER_OVERVIEW = 'OFFER_OVERVIEW',
  SLIP = 'SLIP',
}
